export const primerPrograms = [
  {
    id: "eco-masjid",
    icon: "Sparkles",
    title: "Eco Masjid",
    category: "Eco Masjid",
    description:
      "Program unggulan: menjadikan masjid pusat gerakan peduli lingkungan melalui sedekah sampah — dari sosialisasi, pelatihan pemilahan, simulasi drop box, hingga pembentukan tim berkelanjutan.",
    steps: [
      { text: "Sosialisasi Masjid Jami' Sunan Kalijaga", date: "20–27 Juli" },
      { text: "Sosialisasi SDN 07 Kedungwuni", date: "7 Agustus" },
      { text: "Sosialisasi Pon. Pes. Miftahul Huda", date: "7 Agustus" },
      {
        text: "Pelatihan Pemilahan Sampah, Pencatatan & Administrasi, serta Simulasi Penggunaan Drop Box",
        date: "14 Agustus",
      },
      { text: "Pembentukan Tim dan Pengumpulan Sampah", date: "27 Juli – 14 Agustus" },
      { text: "Monitoring", date: "1 Oktober" },
    ],
  },
  {
    id: "bpjs",
    icon: "HandHeart",
    title: "BPJS Ketenagakerjaan",
    category: "Sosial",
    description:
      "Pendampingan kepesertaan jaminan sosial ketenagakerjaan bagi warga pekerja informal di Kedungwuni Barat — dari observasi hingga pendaftaran.",
    steps: [
      { text: "Observasi", date: "15–30 Juli" },
      { text: "Edukasi", date: "31 Juli – 15 Agustus" },
      { text: "Implementasi", date: "16–19 September" },
    ],
  },
];

export const sekunderPrograms = [
  {
    id: "tahlilan",
    icon: "BookOpen",
    title: "Tahlilan",
    category: "Keagamaan",
    schedule: "Setiap Malam Jum'at",
  },
  {
    id: "manaqib",
    icon: "BookMarked",
    title: "Manaqib & Pengajian",
    category: "Keagamaan",
    schedule: "Setiap Rabu Kliwon",
  },
  {
    id: "tpq",
    icon: "GraduationCap",
    title: "TPQ Al-Maula",
    category: "Pendidikan",
    schedule: "Setiap Jum'at & Ahad",
  },
  {
    id: "one-day",
    icon: "MonitorSmartphone",
    title: "One Day Without Handphone",
    category: "Sosial",
    schedule: "Setiap Ahad",
  },
  {
    id: "bimbel",
    icon: "School",
    title: "Bimbingan Belajar Cendekia",
    category: "Pendidikan",
    schedule: "Setiap Jum'at & Ahad",
  },
  {
    id: "hut-tpq",
    icon: "Flag",
    title: "Perayaan Kemerdekaan TPQ Al-Maula (HUT RI)",
    category: "Acara",
    schedule: "9 Agustus 2026",
  },
  {
    id: "tirakatan",
    icon: "MoonStar",
    title: "Tirakatan Dk. Paesan Utara & Gembong",
    category: "Keagamaan",
    schedule: "16 Agustus 2026",
  },
  {
    id: "hut-ri",
    icon: "Flag",
    title: "HUT RI Dk. Paesan Utara & Gembong",
    category: "Acara",
    schedule: "17 Agustus 2026",
  },
  {
    id: "karnaval",
    icon: "Award",
    title: "Karnaval",
    category: "Acara",
    schedule: "18 Agustus 2026",
  },
  {
    id: "maulid",
    icon: "Sparkles",
    title: "Maulid Nabi Dk. Gembong",
    category: "Keagamaan",
    schedule: "21 Agustus 2026",
  },
  {
    id: "pasar-jajan",
    icon: "Coins",
    title: "Pasar Jajan",
    category: "Acara",
    schedule: "Jadwal Menyusul",
  },
];
